import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ScorecardHeader } from "./ScorecardHeader";
import { default as ScorecardDataModule } from "./ScorecardDataModule";
import { ContentItem } from "./ContentItem";
import * as actions from './redux/scorecard_data_actions';
import moment from "moment-timezone";

export class ScorecardItem extends Component {
  constructor(props) {
    super(props)        
    this.state = {
        startDate: "",
        endDate: "",
        previousWorkDay: "-",
        previousWorkDayValue: "-",
        thirtyDayValue: "-",
        chartData: [],
        opacity: "0.2",
        showScorecard: true,
        currentDayValue: "-"
    }   
    this.isSupervisor = (this.props.User && this.props.User.position === this.props.position.supervisor)
                      || (this.props.User && this.props.User.position === this.props.position.superVisorReadOnly);

    let { User } = this.props;
    this.addPercentageToValue = this.addPercentageToValue.bind(this);
    this.hidingScorecardLoader = this.hidingScorecardLoader.bind(this);
    
    this.getFormattedPreviousWorkDay = this.getFormattedPreviousWorkDay.bind(this);
    this.getFormattedDisplayRange = this.getFormattedDisplayRange.bind(this);
    this.getFormattedTimeValue = this.getFormattedTimeValue.bind(this);
    
    let itemID;
    let groupType;
    let groupName;
    
    if(this.isSupervisor) {
      itemID = props.itemID;
      groupType = props.groupID;
      if(groupType === 'Agent') {
        groupName = '';
      } else {
        groupName = props.groupID;
      }
      
    } else {
      itemID = User.userID;
      groupType = 'Agent';
      groupName = '';
    }
    
    if(this.props.actions.fetchScorecardThirtyDayDataAction) {
      this.state.opacity = "0.1";

      this.props.actions.fetchScorecardThirtyDayDataAction({ 
        scorecardType: props.scorecard.scorecardId,
        id: [itemID],
        groupType: [groupType],
        groupName: [groupName]
      });
    }

    if(this.props.actions.fetchScorecardDailyDataAction) {
      this.props.actions.fetchScorecardDailyDataAction({ 
        scorecardType: props.scorecard.scorecardId,
        id: [itemID],
        groupType: [groupType],
        groupName: [groupName]
      });
    }
  }
  
  componentWillReceiveProps(nextProps) {    
    //current day data
    let currentDayValue;
    if(this.isSupervisor) {
      let itemType = this.props.groupID;
      let itemLookup;
      switch(itemType) {
        case "ManagementUnit":
          itemLookup = "MU";
          break;
        case "Team":
          itemLookup = "Team";
          break;
        case "Agent":
          itemLookup = "Agent";
          break;
        default:
          break;
      }
      if(itemLookup) {
        if(nextProps && nextProps["currentWorkDayData" + itemLookup] && nextProps["currentWorkDayData" + itemLookup].uiModelData) {
          let item = nextProps["currentWorkDayData" + itemLookup].uiModelData[nextProps.itemID];
          if(item) {
            currentDayValue =  item[this.props.scorecard.scorecardKey];
            if(currentDayValue !== this.state.currentDayValue) {
              this.setState({
                currentDayValue : currentDayValue
              })
            }
          }
        }
      }
    }
    
    //determine if we show / hide the card when selected in the dropdown (this is for agent view)
    if(this.props.selectedScorecards !== nextProps.selectedScorecards) {
      
      let scorecardItem = nextProps.selectedScorecards.findIndex(x => {
          if(x !== null && x !== undefined) {
              return x === this.props.scorecard.scorecardId 
          }
          return null
      });

      //if we do not find this.scorecard.scorecardId in the list of selected cards, then do not show the card
      if(scorecardItem === -1) {
        this.setState({
          showScorecard : false
        })
      }

      //if the scorecard is found in the selected list, show the card
      else if(nextProps.selectedScorecards 
              && this.props.scorecard.scorecardId === nextProps.selectedScorecards[scorecardItem]) {
        this.setState({
          showScorecard : true
        })
      }
    }

    //thirty day data
    if( nextProps.scorecardThirtyDayData !== undefined 
      && this.props.scorecard.scorecardId === nextProps.scorecardThirtyDayData.agentScorecardId) {
      if(this.props.scorecardThirtyDayData !== nextProps.scorecardThirtyDayData) {
        
        let formattedTypeSpecificValue = nextProps.scorecardThirtyDayData.agentScorecardValue
        if(this.props.scorecard.scorecardTypeId === 4) {

          let duration =  moment.duration(parseFloat(nextProps.scorecardThirtyDayData.agentScorecardValue), 'minutes')
          formattedTypeSpecificValue = this.getFormattedTimeValue(duration);
        }
        else if(this.props.scorecard.scorecardTypeId === 3) {
          formattedTypeSpecificValue = this.addPercentageToValue(nextProps.scorecardThirtyDayData.agentScorecardValue);
        }
        else if(this.props.scorecard.scorecardTypeId === 2){          
          formattedTypeSpecificValue = this.formatNumeric(nextProps.scorecardThirtyDayData.agentScorecardValue);
        }

        this.setState({
          thirtyDayValue : formattedTypeSpecificValue          
        })
      }
    }

    //daily data
    if( nextProps.scorecardData !== undefined 
      && this.props.scorecard.scorecardId === nextProps.scorecardData.agentScorecardId ) {
      if(this.props.scorecardData !== nextProps.scorecardData) {

        let injectData = []
        nextProps.scorecardData.scorecardDailyData.forEach(element => {
          
          let injectedValue = null
          if(element.agentScorecardValue) {
            if(typeof(element.agentScorecardValue) !== 'number') {
              injectedValue = parseFloat(element.agentScorecardValue.replace(/,/g,'')).toFixed(1);
            }
            else {
              injectedValue = element.agentScorecardValue;
            }
          }
          
          injectData.push({
            x: element.dateKey,
            y: injectedValue
          })          
        });       
      
        let formattedTypeSpecificValue = nextProps.scorecardData.previousWorkDayValue;
        if(this.props.scorecard.scorecardTypeId === 4) {

          let duration =  moment.duration(parseFloat(nextProps.scorecardData.previousWorkDayValue), 'minutes')
          formattedTypeSpecificValue = this.getFormattedTimeValue(duration);
        }
        else if(this.props.scorecard.scorecardTypeId === 3) {
          formattedTypeSpecificValue = this.addPercentageToValue(nextProps.scorecardData.previousWorkDayValue);
        }
        else if(this.props.scorecard.scorecardTypeId === 2){
          formattedTypeSpecificValue = this.formatNumeric(nextProps.scorecardData.previousWorkDayValue);
        }
        
        this.setState({
          startDate : nextProps.scorecardData.startDate,
          endDate: nextProps.scorecardData.endDate,
          previousWorkDay: nextProps.scorecardData.previousWorkDay,          
          previousWorkDayValue: formattedTypeSpecificValue,
          chartData: [injectData]
        })
      }
    }
  }

  hidingScorecardLoader(){
    this.setState({
      opacity:"1.0"
    })
  }
  
  formatNumeric(value) {
    if(value === null || value === undefined) { return "-"; }

    let numb = typeof(value) !== 'number' ? parseFloat(value.replace(/,/g,'')) : value;
    if(numb !== null) {      
      numb = numb.toString().replace(/,/g, '');
      numb = Math.round(numb).toLocaleString('en');
    }
    return numb;
  }

  addPercentageToValue(value) {
    if(value === null || value === undefined) { return "-"; }

    let r = parseFloat(value);
    if(typeof(r) === 'number') {
      r = r.toFixed(1);
    } 
    return r + "%";
  }

  getFormattedPreviousWorkDay(previousWorkDay) {
    let result = "";
    if(previousWorkDay && previousWorkDay !== "-") {
      result = moment(previousWorkDay).format("MM/DD/YYYY");
    }
    return result;
  }

  getFormattedDisplayRange(startDate, endDate) {
    let result = "";
    if(startDate !== "" && endDate !== "") {
      result = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
    }
    return result;
  }

  getFormattedTimeValue(duration) {
    let result = "";

    let seconds = Math.abs(parseInt((duration/1000)%60, 10))
    , minutes = Math.abs(parseInt((duration/(1000*60))%60, 10))
    , hours = Math.abs(parseInt((duration/(1000*60*60))%24, 10));

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    result = hours >= 1 ? hours + ":" + minutes + ":" + seconds : minutes + ":" + seconds ;

    return result;
  }

  render() {
    let {
      previousWorkDayValue,
      thirtyDayValue,
      startDate,
      endDate,
      previousWorkDay,
      opacity,
      chartData,
      currentDayValue
    } = this.state;   

    let displayPreviousWorkDay = this.getFormattedPreviousWorkDay(previousWorkDay);
    let displayRange = this.getFormattedDisplayRange(startDate, endDate);
  
    let colorSymbol = "";
    let colorText = "grey-text";
    let difference = 0;
    let differenceFixed = "-";

    if(previousWorkDayValue !== "-" && thirtyDayValue !== "-") {
        
      if(this.props.scorecard.scorecardTypeId === 4) {
          
          let end = moment(previousWorkDayValue, ["hh:mm:ss", "mm:ss", "ss"]);
          let start = moment(thirtyDayValue, ["hh:mm:ss", "mm:ss", "ss"]);

          // calculate the duration
          let d = moment.duration(end.diff(start));

          if(this.props.scorecard.scorecardId === 5 || this.props.scorecard.scorecardId === 9)
          {
            if (end > start) {
              colorSymbol = "+";
              colorText = "red-text";
            }
            else if (end === start) {
              colorSymbol = "";
              colorText = "green-text";
            }
            else {
                colorSymbol = "-";
                colorText = "green-text";
            }
          }
          else 
          {
            if (end > start) {
              colorSymbol = "+";
              colorText = "green-text";
            }
            else if (end === start) {
              colorSymbol = "";
              colorText = "green-text";
            }
            else {
                colorSymbol = "-";
                colorText = "red-text";
            }
          }
          differenceFixed = this.getFormattedTimeValue(d);
        }
        else {
          let end = parseFloat(previousWorkDayValue);
          let start = parseFloat(thirtyDayValue);
          
          if(this.props.scorecard.scorecardId === 5 || this.props.scorecard.scorecardId === 9) {
            if (end > start) {
              colorSymbol = "+";
              colorText = "red-text";
            }
            else if (end === start) {
              colorSymbol = "";
              colorText = "green-text";
            }
            else {
                colorSymbol = "-";
                colorText = "green-text";
            }
          }
          else {
            if (end > start) {
              colorSymbol = "+";
              colorText = "green-text";
            }
            else if (end === start) {
              colorSymbol = "";
              colorText = "green-text";
            }
            else {
                colorSymbol = "-";
                colorText = "red-text";
            }
          }

          //calculate the difference
          difference = Math.abs(end - start).toFixed(1);
          differenceFixed = difference

          if(this.props.scorecard.scorecardTypeId === 3) {           
            differenceFixed = this.addPercentageToValue(difference)
          }
        }
      }

      let today = new Date();
      today = moment(today).format('MM/DD/YYYY');
      let itemTextLeft, itemTextRight, itemSubTextRight, itemSubTextLeft, itemRightValue, itemLeftValue, currentDayFormatPerformanceMetrics;

      if(this.props.scorecard.scorecardTypeId === 3) { 
        currentDayFormatPerformanceMetrics = this.addPercentageToValue(currentDayValue);
      } else {
        currentDayFormatPerformanceMetrics = this.formatNumeric(currentDayValue);
      }

      if(this.isSupervisor) {
        itemTextLeft = "Current Day";
        itemSubTextLeft = today;
        itemLeftValue = currentDayFormatPerformanceMetrics;

        itemTextRight = "Previous Day";
        itemSubTextRight = displayPreviousWorkDay;
        itemRightValue = previousWorkDayValue;

      } else {
        itemTextLeft = "Previous Work Day";
        itemSubTextLeft = "";
        itemLeftValue = previousWorkDayValue;
        
        itemTextRight = "Difference";
        itemSubTextRight = "Previous - 30 Day Avg";
        itemRightValue = colorSymbol + " " + differenceFixed;
      }
    return (
      <div className={ this.state.showScorecard ? "scard-container cf" : "scard-container cf scard-hide"} key={"container_" + this.props.scorecard.scorecardId}>
        <div className="scorecard_opacity"
          key={"loader_" + this.props.scorecard.scorecardId}
          style={{
            opacity
          }} >   
        
        <ScorecardHeader 
          scHeader={this.props.scorecard.scorecardDisplayName} 
          scToolTipText={this.props.scorecard.toolTipText} 
        />

          <div className="content__wrap">
            <ContentItem  
              position="left"
              itemText={ itemTextLeft }
              itemSubText={ itemSubTextLeft }
              cssColorClass="blue-text"
              itemValue={ itemLeftValue }>
            </ContentItem>
            
            <div className="vertical-divider"></div>
            
            <ContentItem  
              position="right"
              itemText={ itemTextRight }
              itemSubText={ itemSubTextRight }
              cssColorClass={ colorText }
              itemValue={ itemRightValue }>
            </ContentItem>
          </div>

          <div className="horizontal-divider"></div>

          <ContentItem  
            position="bottomleft"
            itemText="30 Day Average" 
            itemSubText={ displayRange }
            cssColorClass="blue-text"
            itemValue={ thirtyDayValue }>
          </ContentItem>
          {
            chartData.length > 0 ?
          <ScorecardDataModule 
            scorecardId = {this.props.scorecard.scorecardId}
            chartData = {chartData}
            startDate = {startDate}
            endDate = {endDate}
            scorecardTypeId = {this.props.scorecard.scorecardTypeId}
            onDataLoad = {this.hidingScorecardLoader}
            timeFormatFunction = {() => this.getFormattedTimeValue}/>      
            : ''
            }
            <div className="loading"></div>
          </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    scorecardData: state.scorecard.scorecardData,
    scorecardThirtyDayData: state.scorecard.scorecardThirtyDayData,
    User: state.common.user,
    selectedScorecards: state.scorecard.selectedScorecards,
    position: state.common.position,
    currentWorkDayDataMU: state.scorecard.currentWorkDayDataMU,
    currentWorkDayDataAgent: state.scorecard.currentWorkDayDataAgent,
    currentWorkDayDataTeam: state.scorecard.currentWorkDayDataTeam
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScorecardItem);



// WEBPACK FOOTER //
// ./src/features/scorecard/ScorecardItem.js